module.exports = __webpack_public_path__ + "img/Packing_1200x800.925d80c8.png";